import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    // },
    // {
    //     cameraLocationId: 'W01Z01',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: `Look Under Seat #1`,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N',
    // },
    {
        cameraLocationId: 'GFG01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Front Garden`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        // cameraLocationLevel2Id: ['GFG01C01_01', 'GFG01C01_02', 'GFG01C01_03', 'GFG01C01_04', 'GFG01C01_05', 'GFG01C01_06'],
        cameraLocationLevel2Id: ['GFG01C01_01'],
    },
    {
        cameraLocationId: 'GFG01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `House Sign`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'GFG02C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Food Bank`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        // isNotClickable: 'Y',
        // cameraLocationIdOfChild: 'Y',
        cameraLocationLevel2Id: ['GFG02C01_01'],
    },
    {
        cameraLocationId: 'GFG02C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Food Box`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'GFG01C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Bench`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['GFG01C01_04', 'GFG01C01_05', 'GFG01C01_06'],
    },
    {
        cameraLocationId: 'GFG01C01_04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Wine Glass`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'GFG01C01_05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pan`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'GFG01C01_06',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Book`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },


    {
        cameraLocationId: 'HPD01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Porch`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HPD01C01_01', 'HPD01C01_02', 'HPD01C01_03'],
    },
    {
        cameraLocationId: 'HPD01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Duffel Bag`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HPD01C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Doorbell`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HPD01C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Food Delivery`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HHL01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Hall`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HHL01C01_01', 'HHL01C01_02'],
    },
    {
        cameraLocationId: 'HHL01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pictures`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HHL01C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Visitor's Book`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HLR01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Living Room`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HLR01C01_01', 'HLR01C01_02', 'HLR01C01_03','HLR01C01_05'],
        // cameraLocationLevel2Id: ['HLR01C01_01', 'HLR01C01_02', 'HLR01C01_03','HLR01C01_04', 'HLR01C01_05',
        //     'HLR01C01_06','HLR01C01_07', 'HLR01C01_08', 'HLR01C01_09','HLR01C01_10', 'HLR01C01_11', 'HLR01C01_12'],
    },
    {
        cameraLocationId: 'HLR01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pictures`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HLR01C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Desk`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
        // cameraLocationLevel2Id: ['HLR01C01_03'],
    },
    {
        cameraLocationId: 'HLR01C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Laptop`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    // {
    //     cameraLocationId: 'HLR01C01_04',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: `Mantlepiece`,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     // cameraLocationIdOfChild: 'Y',
    //     displayMesh: 'N',
    //     // cameraLocationLevel2Id: ['HLR01C01_05'],
    // },
    {
        cameraLocationId: 'HLR01C01_05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Tablet`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HLR01C01_06',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Living Room<br>Sofa & Coffee Table`,
        cameraPosition: null,
        cameraRotation: null,
        // cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HLR01C01_07', 'HLR01C01_08'],
    },
    {
        cameraLocationId: 'HLR01C01_07',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Phone`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HLR01C01_08',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Book`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HLR01C01_09',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Living Room Window`,
        cameraPosition: null,
        cameraRotation: null,
        // cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HLR01C01_10', 'HLR01C01_11'],
    },
    {
        cameraLocationId: 'HLR01C01_10',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `NHS Drawing`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HLR01C01_11',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Window Opener`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HLR01C01_12',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Living Room TV`,
        cameraPosition: null,
        cameraRotation: null,
        // cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HLR01C01_13'],
    },
    {
        cameraLocationId: 'HLR01C01_13',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `TV Remote`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HKT01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Kitchen (Center)`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HKT01C01_01', 'HKT01C01_11','HKT01C01_03','HKT01C01_04','HKT01C01_06','HKT01C01_07', 'HKT01C01_08'],
        // cameraLocationLevel2Id: ['HKT01C01_01', 'HKT01C01_02', 'HKT01C01_03','HKT01C01_04', 'HKT01C01_05'
        //     , 'HKT01C01_06','HKT01C01_07', 'HKT01C01_08', 'HKT01C01_09','HKT01C01_10'],
    },
    {
        cameraLocationId: 'HKT01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pictures`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
// {
//         cameraLocationId: 'HKT01C01_02',
//         floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
//         locationName: `Island`,
//         cameraPosition: null,
//         cameraRotation: null,
//     cameraLocationIdOfChild: 'Y',
//         displayMesh: 'N',
//     isNotClickable: 'Y',
//     // cameraLocationLevel2Id: ['HKT01C01_11','HKT01C01_03','HKT01C01_04'],
//     },
    {
        cameraLocationId: 'HKT01C01_11',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Headphones`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y'
    },
{
        cameraLocationId: 'HKT01C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Book`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y'
    },
{
        cameraLocationId: 'HKT01C01_04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Notebook`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
// {
//         cameraLocationId: 'HKT01C01_05',
//         floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
//         locationName: `Countertop`,
//         cameraPosition: null,
//         cameraRotation: null,
//         // cameraLocationIdOfChild: 'Y',
//         displayMesh: 'N',
//     cameraLocationLevel2Id: ['HKT01C01_06','HKT01C01_07', 'HKT01C01_08'],
//     },
{
        cameraLocationId: 'HKT01C01_06',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Bread`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HKT01C01_07',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Mug`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    cameraLocationIdOfChild: 'Y',
    isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HKT01C01_08',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Microwave`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    cameraLocationIdOfChild: 'Y',
    isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HKT01C01_09',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Kitchen (Left)`,
        cameraPosition: null,
        cameraRotation: null,
    // cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
    cameraLocationLevel2Id: ['HKT01C01_10','HKT01C01_12'],
    },
{
        cameraLocationId: 'HKT01C01_10',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pictures`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    cameraLocationIdOfChild: 'Y',
    isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HKT01C01_12',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Fridge Magnet`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'GRG01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Garage`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['GRG01C01_01', 'GRG01C01_02'],
    },
    {
        cameraLocationId: 'GRG01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Picture`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'GRG01C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Gym Equipment`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HKT02C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Kitchen (Right)`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HKT02C01_00','HKT02C01_01', 'HKT02C01_02', 'HKT02C01_03', 'HKT02C01_04', 'HKT02C01_05'],
    },
    {
        cameraLocationId: 'HKT02C01_00',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pictures`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'HKT02C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `TV Remote`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HKT02C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Book`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HKT02C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Laptop`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HKT02C01_04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Tablet`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HKT02C01_05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Calendar`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'GBG01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Back Garden`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['GBG01C01_01', 'GBG01C01_02','SWK01C01_01'],
    },
    {
        cameraLocationId: 'GBG01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Climbing Frame`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'GBG01C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `TV Remote`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'SWK01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Shed Sign`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'SWK01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Shed`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['SWK01C01_02', 'SWK01C01_03', 'SWK01C01_04'],
    },
    {
        cameraLocationId: 'SWK01C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Ink Pot`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'SWK01C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Postcards`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
    {
        cameraLocationId: 'SWK01C01_04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `TV Remote`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HST01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Stairs`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HST01C01_01'],
    },
    {
        cameraLocationId: 'HST01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Picture`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HLT01C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Bathroom`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HLT01C01_01'],
    },
    {
        cameraLocationId: 'HLT01C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Toilet Rolls`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
        displayMesh: 'N',
    },

    {
        cameraLocationId: 'HLT02C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Landing`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HLT02C01_01'],
    },
    {
        cameraLocationId: 'HLT02C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Picture`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        isNotClickable: 'Y',
        displayMesh: 'N',
    },

    {
        cameraLocationId: 'HB301C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Closed Room`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HB301C01_01', 'HB301C01_02', 'HB301C01_03'],
    },
    {
        cameraLocationId: 'HB301C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `TV Remote`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HB301C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Phone`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HB301C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Tablet`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HB201C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Second Bedroom`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HB201C01_01', 'HB201C01_02'],
    },
    {
        cameraLocationId: 'HB201C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pictures`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HB201C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `TV Remote`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HB101C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Main Bedroom`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HB101C01_01', 'HB101C01_02', 'HB101C01_03', 'HB101C01_04', 'HB101C01_05'],
    },
    {
        cameraLocationId: 'HB101C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Pictures`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HB101C01_02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Phone`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HB101C01_03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Tablet`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HB101C01_04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Notebook`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },
{
        cameraLocationId: 'HB101C01_05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `TV Remote`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },

    {
        cameraLocationId: 'HB401C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Child's Bedroom`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HB401C01_01'],
    },
    {
        cameraLocationId: 'HB401C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Picture`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },







    {
        cameraLocationId: 'HHL02C01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Under Stairs Cupboard<br>(Lockdown Flat)`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['HHL02C01_01'],
    },
    {
        cameraLocationId: 'HHL02C01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Door Handle`,
        cameraPosition: null,
        cameraRotation: null,
        cameraLocationIdOfChild: 'Y',
        displayMesh: 'N',
        isNotClickable: 'Y',
    },






    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: ``,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N',
    // },
];

export {CameraLocationsDB, FLOOR_NUMBER};
